import React, { useEffect } from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";

// components
import LabelList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import {getStateByPath} from "../../../redux/selectors";
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";

function LabelGeneral (props) {
    const path = props.path || 'configuration/label';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
    },[]);


    return (
        <>
            <div>
                {loading && showLoader()}
                <Row>
                    <Col md="12">
                        {componentState && <LabelList path={path} generalPropouse={true}/>}
                    </Col>
                </Row>
            </div>
        </>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
});

export default connect(mapStateToProps, mapActionsToProps)(LabelGeneral)